import { OptionSubCategory, tryLoadAllFullOptionsSync } from 'owa-options-core';

export default function isAnyOptionDirty(currentSubcategory: OptionSubCategory): boolean {
    const options = tryLoadAllFullOptionsSync(currentSubcategory);
    return options
        ? options.reduce((state, option) => state || option.fullOptionFormSettings.isDirty(), false)
        : false;
}
